<mat-drawer-container class="container" [hasBackdrop]="true">
	<mat-drawer #drawer class="container__drawer">
		<mat-icon class="close-drawer-button" svgIcon="close" (click)="close()"></mat-icon>
		<ng-container #drawerContentContainer></ng-container>
	</mat-drawer>
	<mat-drawer-content>
		<ng-content></ng-content>
	</mat-drawer-content>
</mat-drawer-container>
